// Modules
import React from "react";

const ExteriorChairsIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path d="m368 248.81v-200.81a40.04 40.04 0 0 0 -40-40h-144a40.04 40.04 0 0 0 -40 40v200.81a40.05 40.05 0 0 0 -32 39.19v208a8 8 0 0 0 8 8h24a8 8 0 0 0 8-8v-144h208v144a8 8 0 0 0 8 8h24a8 8 0 0 0 8-8v-208a40.05 40.05 0 0 0 -32-39.19zm-208-200.81a24.032 24.032 0 0 1 24-24h144a24.032 24.032 0 0 1 24 24v56h-192zm0 72h192v128h-192zm-24 368h-8v-136h8zm248 0h-8v-136h8zm0-152h-256v-48a24.032 24.032 0 0 1 24-24h208a24.032 24.032 0 0 1 24 24z" />
				<path d="m176 96h40a8 8 0 0 0 0-16h-40a8 8 0 0 0 0 16z" />
				<path d="m240 96h7a8 8 0 0 0 0-16h-7a8 8 0 0 0 0 16z" />
			</g>
		</svg>
	);
};

export default ExteriorChairsIcon;